import { checkElementsInFocus } from './domHelpers';

import { KeyCode } from 'types/enums';

export const preventScrollKeys = (e: Event) => {
  if (
    // @ts-ignore
    (e.keyCode === KeyCode.space ||
      // @ts-ignore
      e.keyCode === KeyCode.arrowUp ||
      // @ts-ignore
      e.keyCode === KeyCode.arrowDown) &&
    !checkElementsInFocus(['input', 'textarea', '.ql-editor'])
  ) {
    e.preventDefault();
  }
};

export const handleScrollKeyPress = (add: boolean) => {
  const htmlCollection: HTMLElement[] = [].slice.call(
    document.getElementsByClassName('viboScrollbar')
  );
  htmlCollection?.forEach((el: HTMLElement) => {
    if (add) {
      el?.addEventListener('keydown', preventScrollKeys);
    } else {
      el?.removeEventListener('keydown', preventScrollKeys);
    }
  });
};

export const smoothScrollTo = (targetY: number, onReached?: () => void) => {
  const scrollbar = document.getElementById('events-scroll');

  scrollbar?.scrollTo({ top: targetY, behavior: 'smooth' });

  function checkScrollPosition() {
    const currentY = scrollbar?.scrollTop ?? 0;
    const isClose = Math.abs(currentY - targetY) < 1;

    if (isClose) {
      onReached?.();
    } else {
      requestAnimationFrame(checkScrollPosition);
    }
  }

  requestAnimationFrame(checkScrollPosition);
};
